const PROMPT_STATES = new Set(['results', 'noResults', 'outsideResults']);
const THRESHOLD = 5;

/**
 * Returns true when the "few results" prompt should render: the message is a
 * non-empty string, the list is in a prompt-eligible state, and the result
 * count is below the threshold (5) but above zero.
 *
 * @param {{ state: string, resultsCount: number, fewResultsMessage: string }} args
 * @returns {boolean}
 */
const shouldShowFewResultsMessage = ({ state, resultsCount, fewResultsMessage }) => {
    if (typeof fewResultsMessage !== 'string' || fewResultsMessage.trim() === '') {
        return false;
    }
    if (!PROMPT_STATES.has(state)) {
        return false;
    }
    return resultsCount > 0 && resultsCount < THRESHOLD;
};

export default shouldShowFewResultsMessage;
